import { ApolloProvider } from '@apollo/client';
import { useClient } from 'hooks';
import type { Children } from 'models';

export const AppApolloProvider = ({ children }: Children) => {
  const apolloClient = useClient();

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};
